<div class="content-wrapper" style="display: inline-block;" #profileLink>
        <div class="profile-link publish-date"
                (mouseover)="showTimeDetailHover($event)"
                (mouseleave)="mouseleaveHandler($event)">
            <span *ngIf="InputDate">{{ InputDate | relativeTime }}</span>
            <div *ngIf="showTooltip" #tooltip [ngStyle]="hoverBoxStyle" class="tooltip">
                {{InputDate | date:'mediumDate'}} at {{InputDate | date:'shortTime'}}
            </div>
        </div>
</div>
